/**
 * @fileoverview gRPC-Web generated client stub for stronachgroup.first.racehorse360
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v0.0.0
// source: stronachgroup/first/racehorse360/application_feature_flag_service.proto

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require("grpc-web");

var google_api_annotations_pb = require("../../../google/api/annotations_pb.js");

var google_api_visibility_pb = require("../../../google/api/visibility_pb.js");

var stronachgroup_first_racehorse360_messages_pb = require("../../../stronachgroup/first/racehorse360/messages_pb.js");
const proto = {};
proto.stronachgroup = {};
proto.stronachgroup.first = {};
proto.stronachgroup.first.racehorse360 = require("./application_feature_flag_service_pb.js");

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.ApplicationFeatureFlagServiceClient =
  function ApplicationFeatureFlagServiceClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.ApplicationFeatureFlagServicePromiseClient =
  function ApplicationFeatureFlagServicePromiseClient(
    hostname,
    credentials,
    options
  ) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullApplicationFeatureFlagsRequest,
 *   !proto.stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse>}
 */
const methodDescriptor_ApplicationFeatureFlagService_PullApplicationFeatureFlags =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.ApplicationFeatureFlagService/PullApplicationFeatureFlags",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullApplicationFeatureFlagsRequest,
    stronachgroup_first_racehorse360_messages_pb.PullApplicationFeatureFlagsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullApplicationFeatureFlagsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullApplicationFeatureFlagsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullApplicationFeatureFlagsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.ApplicationFeatureFlagServiceClient.prototype.pullApplicationFeatureFlags =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.ApplicationFeatureFlagService/PullApplicationFeatureFlags",
      request,
      metadata || {},
      methodDescriptor_ApplicationFeatureFlagService_PullApplicationFeatureFlags,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullApplicationFeatureFlagsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.ApplicationFeatureFlagServicePromiseClient.prototype.pullApplicationFeatureFlags =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.ApplicationFeatureFlagService/PullApplicationFeatureFlags",
      request,
      metadata || {},
      methodDescriptor_ApplicationFeatureFlagService_PullApplicationFeatureFlags
    );
  };

module.exports = proto.stronachgroup.first.racehorse360;
